export default __webpack_public_path__ + "static/media/TF_03.53f42203.png";